import { motion } from "framer-motion";

interface SectionHeadingProps {
  subtitle?: string;
  title: string;
  className?: string;
  light?: boolean;
}

const SectionHeading = ({ subtitle, title, className = "", light }: SectionHeadingProps) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-50px" }}
    transition={{ duration: 0.6 }}
    className={`text-center mb-12 md:mb-16 ${className}`}
  >
    {subtitle && (
      <span className={`text-xs tracking-[0.3em] uppercase font-body ${light ? "text-shiro/50" : "text-muted-foreground"}`}>
        {subtitle}
      </span>
    )}
    <h2 className={`font-display text-3xl md:text-5xl font-light mt-2 ${light ? "text-shiro" : "text-foreground"}`}>
      {title}
    </h2>
    <div className="w-12 h-px bg-aka mx-auto mt-6" />
  </motion.div>
);

export default SectionHeading;
